import { addDoc, collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { app } from '../../util/firebase';

const VentsListPharmacie = (props) => {

    const [listCommandes, setListCommandes ] = useState([])
    const [groupeNumber, setGroupeNumber] = useState(1)

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"commandesClient"),(snapshot)=>{
            setListCommandes(snapshot.docs.map((snap)=> {
                let commande = snap.data()
                commande.id = snap.id
                return commande
            }))
        })
    },[])
    const allCommandes = ()=>{
        let list = []
        
        list = listCommandes.filter(commande=> commande.isValid === props.isValid)
        
        return list.map((commande,index)=>{
            // if(index < groupeNumber*10 -2 && index > groupeNumber*10 - 9){
                return(
                    <tr key={index}>
                        <td><img style={{maxHeight:'40px'}} className="product-img" src={commande.imgSrc_commande}  alt="" /></td>
                        <td>{commande.name_commande}</td>
                        <td>{commande.price_commande}</td>
                        <td>{commande.user.userName.toUpperCase()}</td>
                        <td>{commande.user.email}</td> 
                    </tr>
                )
            // }
        })
    }
    return (
        <div className=''>
            <div className="col-12 bg-light p-3">
                <table className="table table-striped table-hover border rounded">
                    <thead>
                        <tr className='bg-white '>
                            <td>Image </td>
                            <td>Nom Complet </td>
                            <td>Prix en FCFA </td>
                            <td>Nom du client </td>
                            <td>Email </td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            allCommandes()
                        }
                    </tbody>
                </table>
            </div>
            {/* <div className='row my-2'>
                <button className='col-1 ms-auto btn btn-secondary fw-bolder' onClick={e=>setGroupeNumber(groupeNumber-1)}>{"<"}</button>
                <p className='col-1 d-inline m-auto btn btn-light fw-bolder fs-4 text-secondary'>{groupeNumber*10-9 +"-"+ groupeNumber*10}</p>
                <button className='col-1 me-auto btn btn-secondary fw-bolder' onClick={e=>setGroupeNumber(groupeNumber+1)}>{">"}</button>
            </div> */}
        </div>
    );
};

export default VentsListPharmacie;